import {
    OnInit,
    Component,
    Input,
    Output,
    EventEmitter,
    OnDestroy
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn
} from '@angular/forms';
import { map, tap, combineLatest, takeUntil, distinctUntilChanged } from 'rxjs/operators';
import { Observable, BehaviorSubject, Subject, merge } from 'rxjs';

@Component({
    selector: 'app-world-preferences',
    templateUrl: './preferences.component.pug',
    styleUrls: ['./preferences.component.less'],
})
export class WorldPreferencesComponent implements OnInit, OnDestroy {
    _destroySbj: Subject<void> = new Subject();

    @Output() close: EventEmitter<void> = new EventEmitter();
    @Output() preferences: EventEmitter<any> = new EventEmitter();

    paramsForm: FormGroup = new FormGroup({
        units: new FormControl(false),
        color: new FormControl(false),
        decor: new FormControl(false),
        claim: new FormControl(false),
        visual: new FormControl(false)
    });

    constructor(
        private _router: Router,
        private _route: ActivatedRoute
    ) {
    }

    ngOnInit() {
        this._route.queryParams
            .pipe(takeUntil(this._destroySbj))
            .pipe(map(({ units }) => units === 'false' ? false : true))
            .pipe(distinctUntilChanged())
            .pipe(tap((units) => this.paramsForm.patchValue({ units })))
            .subscribe();

        this._route.queryParams
            .pipe(takeUntil(this._destroySbj))
            .pipe(map(({ color }) => color === 'false' ? false : true))
            .pipe(distinctUntilChanged())
            .pipe(tap((color) => this.paramsForm.patchValue({ color })))
            .subscribe();

        this._route.queryParams
            .pipe(takeUntil(this._destroySbj))
            .pipe(map(({ decor }) => decor === 'false' ? false : true))
            .pipe(distinctUntilChanged())
            .pipe(tap((decor) => this.paramsForm.patchValue({ decor })))
            .subscribe();

        this._route.queryParams
            .pipe(takeUntil(this._destroySbj))
            .pipe(map(({ claim }) => claim === 'false' ? false : true))
            .pipe(distinctUntilChanged())
            .pipe(tap((claim) => this.paramsForm.patchValue({ claim })))
            .subscribe();

        this._route.queryParams
            .pipe(takeUntil(this._destroySbj))
            .pipe(map(({ visual }) => visual === 'false' ? false : true))
            .pipe(distinctUntilChanged())
            .pipe(tap((visual) => this.paramsForm.patchValue({ visual })))
            .subscribe();

        const units$ = this.paramsForm.controls.units.valueChanges
            .pipe(map((units: string) => !units ? { units } : { units: null }));

        const color$ = this.paramsForm.controls.color.valueChanges
            .pipe(map((color: string) => !color ? { color } : { color: null }));

        const decor$ = this.paramsForm.controls.decor.valueChanges
            .pipe(map((decor: string) => !decor ? { decor } : { decor: null }));

        const claim$ = this.paramsForm.controls.claim.valueChanges
            .pipe(map((claim: string) => !claim ? { claim } : { claim: null }));

        const visual$ = this.paramsForm.controls.visual.valueChanges
            .pipe(map((visual: string) => !visual ? { visual } : { visual: null }));

        merge(units$, color$, decor$, claim$, visual$)
            .pipe(takeUntil(this._destroySbj))
            .pipe(tap((preferences) => {
                this.preferences.emit(preferences);
            }))
            .subscribe();
    }

    ngOnDestroy() {
        this._destroySbj.next();
        this._destroySbj.complete();
    }

    onClose() {
        this.close.emit();
    }
}
